export const keyboardButtons = {
  ENTER: 'Enter',
  SPACE: 'Space',
  DOWN: 'ArrowDown',
  UP: 'ArrowUp',
  TAB: 'Tab',
};
